// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aBib","question":"styles_question__1bVHU","description":"styles_description__2t7Q2"};